import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Customer from '../views/Customer.vue'
import User from '../views/User.vue'
import Subscription from '../views/Subscription.vue'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/customer/:customerId(\\d+)',
    name: 'customer',
    component: Customer,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'user/:userId(\\d+)',
        name: 'user',
        component: User
      },
      {
        path: 'subscription/:subscriptionId(\\d+)',
        name: 'subscription',
        component: Subscription
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/**
 * This method is triggered each time the user reloads the page or navigates to a new route.
 * Redirects to login if user is not logged in or else it sends you to the requested route.
 * @param {Route} to: The target Route Object being navigated to.
 * @param {Route} from: The current route being navigated away from.
 * @param {Function} next: Must be called to resolve the hook and navigate the user.
 */
router.beforeEach((to, from, next) => {
  let authenticated = store.state.isLoggedIn
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (authenticated === null) {
      store.dispatch('checkIfLoggedIn').then(function (response) {
        let auth = store.state.isLoggedIn
        if (auth) {
          next()
        } else {
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      })
    } else {
      if (authenticated) {
        next()
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    }
  } else {
    if (to.path === '/login') {
      if (authenticated === null) {
        store.dispatch('checkIfLoggedIn').then(function (response) {
          let auth = store.state.isLoggedIn
          if (auth) {
            next('/')
          } else {
            next()
          }
        })
      } else {
        if (authenticated) {
          next('/')
        } else {
          next()
        }
      }
    } else {
      next()
    }
  }
})

export default router
